import { useAdminDetails, useSavedWhitelabel } from "@/v2/stores";
import { useIsSuperAdmin } from "./useAuth";

/**
 * Returns the whitelabel ID to use for API calls:
 * - Super admins: the whitelabel selected in the navbar
 * - Regular admins: their assigned whitelabel ID
 */
export function useEffectiveWhitelabelId(): number | null {
  const adminDetails = useAdminDetails();
  const savedWhitelabel = useSavedWhitelabel();
  const isSuper = useIsSuperAdmin();

  return isSuper ? savedWhitelabel : (adminDetails?.whiteLabelId ?? null);
}
